import React, { useState } from 'react';
import { Button, CircularProgress, Stack } from '@mui/material';

import { useActionDispatch } from '../hooks/useActionDispatch';
import type { Action } from '../types';

type ActionListProps = {
  actions: Action[];
  typeKey: string;
};

const ActionButton: React.FC<{ action: Action; typeKey: string }> = ({ action, typeKey }) => {
  const dispatch = useActionDispatch(typeKey);
  const isAsync = action.kind === 'dismiss';
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (isAsync) setIsLoading(true);
    try {
      await dispatch(action);
    } finally {
      if (isAsync) setIsLoading(false);
    }
  };

  return (
    <Button
      variant="text"
      color="primary"
      size="small"
      disabled={isLoading}
      onClick={handleClick}
      sx={{ textTransform: 'none', p: 0, minWidth: 'auto' }}
    >
      {isLoading ? <CircularProgress size={14} color="inherit" /> : `${action.label} →`}
    </Button>
  );
};

export const ActionList: React.FC<ActionListProps> = ({ actions, typeKey }) => {
  if (actions.length === 0) return null;

  return (
    <Stack direction="row" spacing={2}>
      {actions.map((action, i) => (
        <ActionButton key={action.label ?? i} action={action} typeKey={typeKey} />
      ))}
    </Stack>
  );
};
